import { Node } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

const BlocksWithLabels = Node.create({
  name: 'BlocksWithLabels',

  addOptions() {
    return {
      tags: ['div', 'section', 'article', 'aside', 'paragraph', 'heading', 'blockquote', 'ol', 'ul'],
    };
  },

  addNodeView() {
    return ({ HTMLAttributes }) => {
      const { tag } = HTMLAttributes;

      // Основной контейнер блока
      const wrapper = document.createElement('div');
      wrapper.className = `prose-tag prose-tag-${tag}`;
      wrapper.style.position = 'relative';

      // Контейнер для текста блока
      const content = document.createElement('div');
      content.className = 'block-content';
      content.style.flex = '1';

      wrapper.appendChild(content);

      return { dom: wrapper, contentDOM: content };
    };
  },

  parseHTML() {
    return this.options.tags.map(tag => ({ tag }));
  },

  renderHTML({ node }) {
    return [node.attrs.tag, { class: 'custom-block' }, 0];
  },

  addProseMirrorPlugins() {
    const tagMap = {
      paragraph: 'p',
      heading: level => `h${level}`,
      blockquote: 'blockquote',
      div: 'div',
      section: 'section',
      article: 'article',
      aside: 'aside',
      ol: 'ol',
      ul: 'ul',
    };

    return [
      new Plugin({
        props: {
          decorations(state) {
            const decorations = [];
            state.doc.descendants((node, pos) => {
              if (node.isBlock) {
                let tag = tagMap[node.type.name] || node.type.name;
                if (node.type.name === 'heading') {
                  tag = tagMap.heading(node.attrs.level || 1);
                }

                // Создаем декорацию для блоков и списков
                const deco = Decoration.node(pos, pos + node.nodeSize, {
                  class: `prose-tag-${tag}`,
                });

                decorations.push(deco);

                // Проверяем и добавляем стили для элементов списка (li)
                if (node.type.name === 'ol' || node.type.name === 'ul') {
                  node.forEach((child, childPos) => {
                    if (child.type.name === 'list_item') {
                      const listItemDeco = Decoration.node(
                        pos + childPos + 1, // Позиция элемента списка
                        pos + childPos + child.nodeSize,
                        { class: 'prose-tag-li' }
                      );
                      decorations.push(listItemDeco);
                    }
                  });
                }
              }
            });
            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});

export default BlocksWithLabels;
